import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { Observable, Subscription } from 'rxjs-compat';
import { TextosPredefinidosFilter } from '../../models/textos-predefinidos-filter.model';

@Component({
  selector: 'app-textos-predefinidos-filter',
  templateUrl: './textos-predefinidos-filter.component.html',
  styleUrls: ['./textos-predefinidos-filter.component.scss']
})
export class TextosPredefinidosFilterComponent implements OnInit {
  subscription: Subscription;
  filter: TextosPredefinidosFilter;

  @Output() notify: EventEmitter<TextosPredefinidosFilter> = new EventEmitter<TextosPredefinidosFilter>();

  constructor(
    public thisDialogRef: MatDialogRef<TextosPredefinidosFilterComponent>,
    private i18n: I18n,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    this.filter = data.filter;
  }

  ngOnInit() {
    this.subscription = Observable.fromEvent(document, 'keypress').subscribe((e: KeyboardEvent ) => {
      if (e.key === 'Enter') {
        this.apply();
      }
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  reset() {
    this.filter.clear();
    this.apply();
  }

  apply() {
    this.filter.updated();
    this.notify.emit(this.filter);
    this.thisDialogRef.close();
  }

  dismiss() {
    this.thisDialogRef.close();
  }
}
